var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('h1',[_vm._v("Domain")]),_c('Gallery'),_c('Announcement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }